module.exports = __webpack_public_path__ + "static/media/clear.cad84824.svg";